var generate = function generate(num, fn) {
  var a = [];

  for (var i = 0; i < num; ++i) {
    a.push(fn(i));
  }

  return a;
};

var replicate = function replicate(num, val) {
  return generate(num, function () {
    return val;
  });
};

var concat = function concat(a, b) {
  return a.concat(b);
};

var flatten = function flatten(a) {
  var r = [];

  for (var j = 0, J = a.length; j < J; ++j) {
    for (var i = 0, I = a[j].length; i < I; ++i) {
      r.push(a[j][i]);
    }
  }

  return r;
};

var chunksOf = function chunksOf(n, a) {
  var b = [];

  for (var i = 0, l = a.length; i < l; i += n) {
    b.push(a.slice(i, i + n));
  }

  return b;
};

module.exports = {
  generate: generate,
  replicate: replicate,
  concat: concat,
  flatten: flatten,
  chunksOf: chunksOf
};